import React from "react";
import {
  AppBar,
  Box,
  Stack,
  Toolbar,
  IconButton,
  Button,
  Typography,
} from "@mui/material";
import { ArrowBack, VerifiedUser, GppMaybe } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../hooks/auth";

const IndividualBox = (props) => (
  <Box
    sx={{
      display: "flex",
      backgroundColor: "white",
      width: "90%",
      justifyContent: "flex-start",
      padding: "10px",
      borderRadius: "12px",
      marginTop: "10px",
      boxShadow: '2px 2px 7px -4px rgba(0,0,0,0.75)'
    }}
  >
    <Typography width="50%">{props.title}</Typography>
    <Typography>{props.data}</Typography>
  </Box>
);

export const ProfileInfo = () => {
  const { cookies } = useAuth();
  const navigate = useNavigate()
  const handleGoBack = () => {
    navigate("/more")
  }

  return (
    <Box>
      <AppBar position="sticky">
        <Toolbar disableGutters={true} >
          <Stack
            direction="row"
            sx={{
              display: "flex",
              alignItems: "center",
              color: "white",
            }}
          >
            <IconButton
            aria-label="go back"
              sx={{
                paddingLeft: "10px",
                paddingRight: "10px",
                color: "white",
              }}
              onClick={handleGoBack}
            >
              <ArrowBack />
            </IconButton>
            <Typography variant="h5">Profile Info</Typography>
          </Stack>
        </Toolbar>
      </AppBar>
      <Box
        sx={{
          height: "204px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Stack spacing={2}>
          <img
            src="FORTUNE_PRECIOUS.jpg"
            alt="fortune precious pic"
            className="profile_pic"
          />
          <Stack direction="row" spacing={1} color="primary.main">
            <Typography variant="body1" display="inline-block">
              {`${cookies.data.first_name} ${cookies.data.last_name}`}
            </Typography>
            {cookies.data.is_verified ? <VerifiedUser /> : <GppMaybe sx={{color:"orange"}} />}
          </Stack>
        </Stack>
      </Box>
      <Stack
        sx={{
          position: "absolute",
          top: "260px",
          bottom: "0",
          width: "100vw",
          alignItems: "center",
        }}
      >
        <IndividualBox title='Matric No.' data={cookies.data.matric_no} ></IndividualBox>
        <IndividualBox title='Course Of Study' data={cookies.data.course_of_study} ></IndividualBox>
        <IndividualBox title='Hall' data={cookies.data.hall} ></IndividualBox>
        <IndividualBox title='Meal Option' data={cookies.data.meal_option} ></IndividualBox>
        <IndividualBox title='Level' data={cookies.data.level} ></IndividualBox>
        <Button variant="contained" sx={{
          marginTop: '30px', color: 'white'
        }}>View Dashboard</Button>
      </Stack>
    </Box>
  );
};
